<!-- eslint-disable vue/no-unused-refs -->
<template>
  <QS-scroller-box>
    <div>
      <el-steps style="margin-top: 20px;" :active="active" finish-status="success" align-center>
        <el-step ref="step1" title="填写银行卡信息"></el-step>
        <el-step title="银行鉴权校验"></el-step>
        <el-step title="完成绑定"></el-step>
      </el-steps>
      <!-- 第一步 -->
      <Step1 v-if="this.active===0" ref="Step1" :stepsParams="stepsParams" @success="plus" @failed="step1Failed"/>
      <!-- 第二步 -->
      <Step2 v-else-if="this.active===1" :stepsParams="stepsParams" ref="Step2" @success="submitSuccess" @failed="step2Failed" />
      <!-- 第三步 -->
      <Step3 v-else ref="Step3" :stepsParams="stepsParams" />
    </div>
    <!-- active===0 第一步  active===1 第二步 active===3 第三步 -->
    <template slot="bottomAction">
      <el-button v-if="this.active != 3" @click="back" size="mini">取消</el-button>
      <el-button v-if="this.active === 1" @click="minus" size="mini" type="primary">上一步</el-button>
      <el-button :loading="nextLoading" v-if="this.active === 0" @click="nextStep" size="mini" type="primary">下一步</el-button>
      <el-button :loading="submitLoading" v-if="this.active === 1" @click="submit" size="mini" type="primary">提交</el-button>
      <el-button v-if="this.active === 3" @click="back" size="mini" type="primary">确认并返回列表</el-button>
    </template>
  </QS-scroller-box>
  </template>
<script>
import Step1 from '../components/pingAnBankWalletWithholdConfig/steps/step1.vue'
import Step2 from '../components/pingAnBankWalletWithholdConfig/steps/step2.vue'
import Step3 from '../components/pingAnBankWalletWithholdConfig/steps/step3.vue'

export default {
  data() {
    return {
      stepsParams: null, // 参数存储
      params: null,
      active: 0,
      nextLoading: false, // 下一步
      submitLoading: false, // 提交
    }
  },
  components: { Step1, Step2, Step3 },
  mounted() {
    this.initStepClickListeners()
    const data = JSON.parse(this.$route.query.data)
    this.params = data
    // 将字典传递给子组件
    this.$refs.Step1.receiveData(data)
  },
  methods: {
    back() {
      this.$refreshBack(true)
    },
    // 第三步直接就是完成状态不存在提交 所以指定active===3
    submitSuccess() {
      this.submitLoading = false
      this.active = 3
    },
    // 取消步骤一下一步按钮加载状态
    step1Failed() {
      this.nextLoading = false
    },
    // 取消步骤二提交按钮加载状态
    step2Failed() {
      this.submitLoading = false
    },
    // 上一步
    minus() {
      this.active--
    },
    // 从第一步到第二步
    plus(val) {
      if (val) {
        this.stepsParams = val
      }
      this.nextLoading = false
      this.active++
    },
    // 下一步
    nextStep() {
      this.nextLoading = true
      this.$refs.Step1.nextStep()
    },
    // 提交
    submit() {
      this.submitLoading = true
      this.$refs.Step2.submit(this.params.mode)
    },
    // 监听是否点击了第一步的标题
    initStepClickListeners() {
      const step1 = this.$refs.step1.$el
      step1.addEventListener('click', () => {
        if (this.active === 1) {
          this.active = 0
        }
      })
    },
  },
  deactivated() {
    this.nextLoading = false
  },
}
</script>
